var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-form"},[_c('parser',{attrs:{"form-conf":_vm.formConf},on:{"submit":_vm.sumbitForm1}}),_c('el-button',{on:{"click":_vm.change}},[_vm._v("change")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }